export default __webpack_public_path__ + "static/media/serviceDash2.54455114.PNG";